import * as R from 'ramda';
export default function User(data){
    let user = data || {};
    let professions = [];
    if(!Array.isArray(user.professionalSituation)){
        if(!R.isNil(user.professionalSituation) && user.professionalSituation !== "" && !Number.isInteger(user.professionalSituation) && user.professionalSituation !== 0 && user.professionalSituation !== "0"){
            let allProfs = user.professionalSituation.split(',');
            if(Array.isArray(allProfs)){
                allProfs.forEach(p => {professions.push(p.trim())});
            }
            else{
                professions.push(allProfs);
            }
        }
    }
    

    this.id = user.id;
    this.email = user.email;
    this.emailConfirmed = user.emailConfirmed;
    this.phoneNumber = user.phoneNumber;
    this.gender = user.gender === '0' ? undefined : user.gender;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.birthDate = R.isNil(user.birthDate) || user.birthDate === '0001-01-01T00:00:00Z' ? undefined: new Date(user.birthDate);
    this.birthPlace = user.birthPlace;
    this.departmentNumber = R.isNil(user.departmentNumber) ? "" : user.departmentNumber;
    this.country = R.isNil(user.country) ? "FR" : user.country;
    this.civilStatus = user.civilStatus === '0' ? undefined : user.civilStatus;
    this.hasChildren = user.hasChildren;
    this.professionalSituation = professions;
    this.processNumber = user.processNumber;
    this.hasRepresentativeMessage = user.hasRepresentativeMessage;
    this.onBoardingStep = user.onBoardingStep;
    this.setupCompletedDate = user.setupCompletedDate === '0001-01-01T00:00:00Z' || user.setupCompletedDate === null || user.setupCompletedDate === undefined ? undefined : new Date(user.setupCompletedDate);
    this.stripeCustomerId = user.stripeCustomerId;
    this.removeSetupFee = user.removeSetupFee;
    this.paymentMethods = R.isNil(user.paymentMethods) ? [] : user.paymentMethods;
    this.billedByPartner = user.billedByPartner;
    this.etablissementId = user.etablissementId;
    this.partnerId = user.partnerId;
    this.daysOfTraining = user.daysOfTraining;
    this.isEnabled = R.isNil(user.isEnabled) ? true : user.isEnabled;
    this.isEtablissementAdmin = R.isNil(user.isEtablissementAdmin) ? true : user.isEtablissementAdmin;
    this.childrens = R.isNil(user.childrens) ? [] : user.childrens;
    this.hasHrDocuments = user.hasHrDocuments;
    this.hasPets = user.hasPets;
    this.recipientEmail = user.recipientEmail;
    this.userName = user.userName;
}